import { useTranslation } from "react-i18next";
import { useUserState } from "@gx1/gx-npm-lib";
import { TypographyComponent } from "@gx1/gx-npm-ui";
import styles from "./header.styles.module.scss";

const Header = () => {
  const { t } = useTranslation();
  const { firstName } = useUserState();
  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <TypographyComponent isMasked={true} color="gartnerBlue" boldness="medium" styling="p3" element={"h1"}>
          {`${t("Welcome")} ${firstName}!`}
        </TypographyComponent>
      </div>
    </section>
  );
};

export default Header;
